import {useEffect, useState} from 'react';
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";

import Alert from "../../../alert/Alert";
import Field from "../../Field"
import Loading from "../../../generic/Loading";
import UseGetterNodeValue from "../../hooks/UseGetterNodeValue";

import MonthDays from "./MonthDays";
import WeekDays from "./WeekDays";

import {DataDrivenLabel, InfoLabel, SettingsLabel} from "../../../../config/Config";
import {Monthly, Options, Weekly, Hourly} from './Frequencies'

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const DataDriven = (props) => {
    const {journey, currentNode} = props

    const initialFrequency = UseGetterNodeValue(
        currentNode, 'settings', 'frequency', ''
    )

    const [minDate, setMinDate] = useState('')
    const [loading, setLoading] = useState(false)
    const [frequency, setFrequency] = useState(initialFrequency)


    useEffect(() => {

    }, [frequency])



    const Information = {
        className: 'alert-primary',
        message  : `Data Driven is an input component driven by your audience data. `,
    }


    const Id = {
        tab         : 'info',
        name        : 'id',
        type        : 'text',
        label       : 'Component Id',
        wrapper     : 'form-group',
        disabled    : true,
        canCopy     : true,
        defaultValue: currentNode.id,
        node        : currentNode,
    }


    const Title = {
        tab         : 'info',
        name        : 'title',
        type        : 'text',
        label       : 'Title',
        wrapper     : 'form-group',
        placeholder : 'Type an descriptive title',
        node        : currentNode,
        defaultValue: DataDrivenLabel,
    }


    const Description = {
        tab        : 'info',
        name       : 'description',
        type       : 'textarea',
        label      : 'Description',
        wrapper    : 'form-group',
        className  : 'form-control',
        placeholder: 'Type a short description',
        node       : currentNode,
    }


    const StartDate = {
        tab        : 'settings',
        name       : 'start_date',
        type       : 'datetime-local',
        label      : 'Start date',
        wrapper    : 'form-group',
        required   : true,
        placeholder: 'Choose start date',
        node       : currentNode,
        onBlur     : (value) => {
            setMinDate(value)
        }
    }


    const EndDate = {
        tab        : 'settings',
        name       : 'end_date',
        type       : 'datetime-local',
        label      : 'End date',
        wrapper    : 'form-group',
        required   : true,
        placeholder: 'Choose end date',
        node       : currentNode,
        min        : minDate,
    }


    const Frequency = {
        tab      : 'settings',
        name     : 'frequency',
        type     : 'radio',
        label    : 'Frequency',
        wrapper  : 'form-group',
        className: 'form-control',
        options  : Options,
        inline   : true,
        required : true,
        value    : frequency,
        node     : currentNode,
        onChange : (value) => {
            setFrequency(value)
        }
    }


    const WeekDay = {
        tab            : 'settings',
        name           : 'weekday',
        type           : 'select',
        label          : 'Choose a day',
        wrapper        : 'form-group',
        className      : 'input-sm',
        classNamePrefix: 'input-sm',
        placeholder    : 'Choose a week day',
        required       : true,
        isMulti        : false,
        isSearchable   : true,
        options        : WeekDays,
        node           : currentNode,
    }


    const MonthDay = {
        tab            : 'settings',
        name           : 'monthday',
        type           : 'select',
        label          : 'Choose a day',
        wrapper        : 'form-group',
        className      : 'input-sm',
        classNamePrefix: 'input-sm',
        placeholder    : 'Choose a month day',
        required       : true,
        isMulti        : false,
        isSearchable   : true,
        options        : MonthDays,
        node           : currentNode,
    }


    const ChooseTime = {
        tab        : 'settings',
        name       : 'start_time',
        type       : 'time',
        label      : 'Start time',
        wrapper    : 'form-group',
        placeholder: 'Choose start time',
        required   : true,
        node       : currentNode,
    }


    return (
        <div>
            {loading && <Loading/>}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">
                        <Alert {...Information} />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <div>
                                        <Field {...StartDate} />
                                        <Field {...EndDate} />
                                        <Field {...Frequency} />
                                        {frequency == Weekly && <Field {...WeekDay} />}
                                        {frequency == Monthly && <Field {...MonthDay} />}
                                        {frequency != Hourly && <Field {...ChooseTime} />}
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field {...Id}/>
                                        <Field {...Title}/>
                                        <Field {...Description}/>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default DataDriven;